<template>
  <div class="stay-connected grid-container fluid">
    <div class="grid-container">
      <div class="inner-container pvl grid-x align-center">
        <div class="header cell medium-10">
          <h2>{{ $t("stay-connected.stay-connected") }}</h2>
          <div class="subtitle">
            {{ $t("stay-connected.sign-up-email") }}
          </div>
        </div>
        <div class="cell medium-4 mvm">
          <a
            class="button content-type-form"
            href="https://phila.formstack.com/forms/phila_gov_stay_connected"
            aria-label="Sign up for email updates"
          >
            {{ $t("stay-connected.sign-up") }}
            <i
              class="fas fa-angle-right fa-lg"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
